module.exports = __webpack_public_path__ + "img/phone-top-1.99f0163c.png";